import React from 'react'

const MailIcon = () => {
  return (
    <svg className="icon mail-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18">
      <path d="M4,4H20a2,2,0,0,1,2,2V18a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4Z" transform="translate(-1 -3)"/>
      <polyline points="21 3 11 10 1 3" />
    </svg>
  )
}

export default MailIcon


// WEBPACK FOOTER //
// ./src/assets/icons/mail-icon.js